/**
 * Created by daniel on 22/04/17.
 */

import React, {Component} from 'react';
import ContentFrame from "./ContentFrame";
import {connect} from "react-redux";
import {getUiItemCoords, getUiSelectedItem} from "../../state/ui/selectors";
import {getContentItem} from "../../state/content/selectors";
import {deleteContentItem, hideContentItem} from "../../state/content/actions";
import {setUiSelectedContentItem} from "../../state/ui/actions";

class ContentFrameContainer extends Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleHideItem = this.handleHideItem.bind(this);
    this.handleShowItem = this.handleShowItem.bind(this);
  }
  handleDelete() {
    //TODO implement the recycle bin
    //this.props.dispatch(orphanContentItem(this.props.selectedItem.contentId));
    this.props.dispatch(deleteContentItem(this.props.selectedItem.contentId));
    this.props.dispatch(setUiSelectedContentItem(null));
  };
  
  handleClose() {
    this.props.dispatch(setUiSelectedContentItem(null));
  };
  
  handleHideItem() {
    this.props.dispatch(hideContentItem(this.props.selectedItemProps.contentId, true));
  };
  
  handleShowItem() {
    this.props.dispatch(hideContentItem(this.props.selectedItemProps.contentId, false));
  };
  
  render() {
    if (!this.props.selectedItem) return null;
    let name = this.props.selectedItemProps.contentName ? this.props.selectedItemProps.contentName : this.props.selectedItemProps.configName;
    return (
      <ContentFrame
        position={this.props.selectedItemCoords}
        title={name}
        hideable={this.props.selectedItemProps.editorHideable}
        hidden={this.props.selectedItemProps.contentHidden}
        showItem={this.handleShowItem}
        hideItem={this.handleHideItem}
        canDelete={this.props.selectedItemProps.editorDeletable}
        delete={this.handleDelete}
        closeFrame={this.handleClose}
      />
    );
  }
}

function mapStateToProps(state) {
  let selectedItem = getUiSelectedItem(state);
  let selectedItemProps = selectedItem && getContentItem(state, selectedItem.contentId);
  let selectedItemCoords = selectedItem && getUiItemCoords(selectedItem.contentId, "canvas-element");

  return {
    selectedItem,
    selectedItemProps,
    selectedItemCoords
  };
}

function mapDispatchToProps(dispatch) {
  return {dispatch};
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentFrameContainer);


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ContentFrameContainer.js